import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { burnUpReportEntrypoint } from '@atlassian/jira-spa-apps-next-gen-reports-burnup/entrypoint.tsx';

export const BurnUpReportPageEntrypoint = createPageEntryPoint({
	main: burnUpReportEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
